<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <ul>
                            <li><a v-on:click="goTeachersActivities()">Teachers' Activities</a></li>
                            <li class="is-active"><a href="#" aria-current="page">Activities View for {{ teacherName }} </a></li>
                        </ul>
                    </nav>
                </div><br/>
                    
                <div class="columns">
                    <div class="column one-half">
                        <div class="card">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Awarded Behaviors &amp; Points</p>
                                
                                <div style="padding: 10px;">
                                    <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="downloadAsExcel()">Download As Excel</a>
                                </div>
                                <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getSubmittedBehaviors()">
                                    <option selected value="0">Whole year</option>
                                    <option selected value="1">January</option>
                                    <option selected value="2">February</option>
                                    <option selected value="3">March</option>
                                    <option selected value="4">April</option>
                                    <option selected value="5">May</option>
                                    <option selected value="6">June</option>
                                    <option selected value="7">July</option>
                                    <option selected value="8">August</option>
                                    <option selected value="9">September</option>
                                    <option selected value="10">October</option>
                                    <option selected value="11">November</option>
                                    <option selected value="12">December</option>
                                </b-select>
                                <b-select id="sortBy" name="sortBy" v-model="sortBy" class="header-input" @input="sortSubmittedBehavior()">
                                    <option selected value="0">Sort by dates</option>
                                    <option selected value="1">Sort by points</option>
                                </b-select>
                            </div>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns bottom-border">
                                        <div class="column">Behavior</div>
                                        <div class="column is-2" style="text-align: center;">Points<br/>(Scan count: {{ totalScans }})</div>
                                        <div class="column is-2" style="text-align: center;">Total Points<br>{{ totalPoints }}</div>
                                        <div class="column is-2">Student &amp; Kelas</div>
                                        <div class="column is-2">Date</div>
                                    </div>

                                    <div class="columns top-border" v-for="submittedBehavior in sortSubmittedBehavior(submittedBehaviorList)" :key="submittedBehavior._id">
                                        <div class="column">{{ submittedBehavior.positiveID.name }}</div>
                                        <div class="column is-2" style="text-align: center;">{{ submittedBehavior.points }} x {{ submittedBehavior.multiply }}</div>
                                        <div class="column is-2" style="text-align: center;">{{ submittedBehavior.totalPoints }}</div>
                                        <div class="column is-2">{{ submittedBehavior.studentID.firstName }} ({{ submittedBehavior.kelasID.level }} {{ submittedBehavior.kelasID.name }})</div>
                                        <div class="column is-2">{{ displayDate(submittedBehavior.actionDate) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import SideMenu from '../SideMenu'
import axios from 'axios'
import "../public/style.scss";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "TeachersActivities",
    components: {
        SideMenu,
        Loading,
    },
    data() {
        return {
            teacherID: '',
            teacherName: '',
            actionYear: 0,
            actionMonth: 0,
            actionDate: '',
            duration: 0,
            sortBy: 0,
            submittedBehaviorList: [],
            isLoading1: false,
            totalPoints: 0,
            totalScans: 0
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    computed:{     
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()        

        this.teacherID = this.$store.getters.getTeacherID;

        if (this.teacherID.trim.length < 1){
            this.teacherID = localStorage.getItem('TEACHER_ID')
        }

        this.teacherName = this.$store.getters.getTeacherName;

        if (this.teacherName.trim.length < 1){
            this.teacherName = localStorage.getItem('TEACHER_NAME')
        }

        this.duration = currentDate.getMonth() + 1; //just an init value

        this.duration = this.$store.getters.getDurationMonth;

        if (this.duration.trim.length < 1){
            this.duration = localStorage.getItem('DURATION_MONTH')
        }

    },
    mounted(){
        this.$root.$emit('activeSideMenu',"TeachersActivities") 
        this.getSubmittedBehaviors()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        downloadAsExcel(){            
            let self = this;
            self.isLoading1 = true;
            
            var show = 'all';

            if (self.duration == 0){
                show = 'all';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/teachers/activities/view', {
                params: {
                    email: localStorage.getItem('email'),
                    sessionID: localStorage.getItem('sessionID'),
                    action: 'list',
                    show: show,
                    actionYear: self.actionYear,
                    actionMonth: self.actionMonth,
                    teacherID: self.teacherID,
                    output: 'excel'
                }
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.actionDate + "_teachers_activities.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                self.isLoading1 = false;
            })
            .catch(e => {
                console.log("193 Error:" + e)
            }) 
        },
        getSubmittedBehaviors(){
            let self = this;
            self.isLoading1 = true;
            
            var show = 'all';

            if (self.duration == 0){
                show = 'all';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/teachers/activities/view', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        action: 'list',
                        show: show,
                        actionYear: self.actionYear,
                        actionMonth: self.actionMonth,
                        teacherID: self.teacherID
                    }
                })
                .then(response => {
                    console.log("imin 168: ")
                    self.submittedBehaviorList = response.data
                    console.log(self.submittedBehaviorList)
                    self.totalPoints = 0
                    self.totalScans = 0
                    for (var i = 0; i < self.submittedBehaviorList.length; i++){
                        self.totalPoints = self.totalPoints + self.submittedBehaviorList[i].totalPoints
                        self.totalScans = self.totalScans + 1
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log("174 Error:" + e)
                }) 
        },
        sortSubmittedBehavior(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'totalPoints', 'desc');  //we're using the magical lodash function here
            }else{  //name
                return _.orderBy(arrays, 'actionDate', 'desc');  //we're using the magical lodash function here
            }            
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        goTeachersActivities(id,name){
            this.$router.push({
                name: "TeachersActivities"
            });
        },
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    margin-left: 10px;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-button{
    margin-top: 10px;
    margin-left: 10px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.text-center{
    text-align: center;
}
.header-input{
    margin: 10px;
}
.breadcrumb{
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Teachers/ActivitiesView.vue